import React from "react";
import styles from "./CommitmentBox.module.css";

export interface Commitment {
	commitmentId: number;
	commitmentDefinitionName: string;
	theme: string;
	summary: string;
}
interface CommitmentBoxProps {
	readonly commitment: Commitment;
}
const CommitmentBox = ({ commitment }: CommitmentBoxProps) => (
	<div className={styles.container}>
		<div className={styles.commitmentDefinitionName}>{commitment.commitmentDefinitionName}</div>
		<div className={styles.theme}>{commitment.theme}</div>
		<div className={styles.summary}>{commitment.summary}</div>
	</div>
);

export default CommitmentBox;
